// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-time.v-textarea.v-text-field.v-text-field--solo .v-label {\r\n  top: 5px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
